import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formLabelsTheme,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectCountry,
  selectParameter,
  selectParameter2,
  selectPhoneType,
} from "../businessParameter/businessParameterSlice";
// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { selectCountryAll } from "../location/locationSlice";
import { v4 as uuidv4 } from "uuid";
import {
  addOutboundParty,
  addOutboundTransportations,
  editOutboundParty,
  editOutboundTransportations,
  fetchOutboundTransportations,
} from "./outboundSlice";
import { ModalPartyRadio } from "./ModalPartyRadio";
import { selectPagination } from "../../modules/Auth";
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ModalCreateTranspotation = ({
  isOpen,
  setShow,
  setFormValues,
  formValues,
  setFields,
  fields,
  row,
  setRow,
  id,
  showParty,
  setShowParty,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const dataClientRelated = useSelector(selectParameter2);
  const dataCountry = useSelector(selectCountryAll);
  const [get, setGet] = useState(false);
  const paginationSet = useSelector(selectPagination);

  useEffect(() => {
    if (row !== null) {
      console.log("jalan");
      setFormValues({
        license_plate: {
          value: row.license_plate,
          error: false,
          required: "N",
        },
        party_id: {
          value: row.party_id,
          error: false,
          required: "Y",
        },
        party_code: {
          value: row.party_code,
          error: false,
          required: "N",
        },
        party_name: {
          value: row.party_name,
          error: false,
          required: "N",
        },
        driver_name: {
          value: row.driver_name,
          error: false,
          required: "N",
        },
        driver_contact: {
          value: row.driver_contact,
          error: false,
          required: "N",
        },
        description: {
          value: row.description,
          error: false,
          required: "N",
        },
      });
    }
  }, [row]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }
    const params = [
      {
        outbound_id: id,
        license_plate: formValues.license_plate.value,
        party_id: formValues.party_id.value,
        driver_name: formValues.driver_name.value,
        description: formValues.description.value,
        driver_contact: formValues.driver_contact.value,
      },
    ];

    const paramsId = [
      {
        outboundtransportation_id:
          row === null ? "" : row.outboundtransportation_id,
        license_plate: formValues.license_plate.value,
        party_id: formValues.party_id.value,
        driver_name: formValues.driver_name.value,
        description: formValues.description.value,
        driver_contact: formValues.driver_contact.value,
      },
    ];

    console.log(params);
    console.log(paramsId);
    if (row === null) {
      try {
        const response = await dispatch(addOutboundTransportations(params));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(
            fetchOutboundTransportations({
              outbound_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await setShow(false);

          await window.scrollTo(0, 650);
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      try {
        const response = await dispatch(editOutboundTransportations(paramsId));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await setShow(false);
          await window.location.reload();
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  const handleClose = () => {
    setFormValues({
      license_plate: {
        value: "",
        error: false,
        required: "N",
      },
      party_id: {
        value: "",
        error: false,
        required: "Y",
      },
      party_code: {
        value: "",
        error: false,
        required: "N",
      },
      party_name: {
        value: "",
        error: false,
        required: "",
      },
      driver_name: {
        value: "",
        error: false,
        required: "N",
      },
      driver_contact: {
        value: "",
        error: false,
        required: "N",
      },
      description: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setRow(null);
    setShow(false);
  };

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Add Transportation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <RedditTextField
                  label="Carrier’s Vehicle No."
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="license_plate"
                  onChange={handleChange}
                  value={formValues.license_plate.value}
                />

                <Row>
                  <Col xs={10} sm={3} md={9} lg={9}>
                    <RedditTextField
                      required
                      label="Carrier Code"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={formValues.party_code.value}
                      error={formValues.party_code.error}
                      helperText={
                        formValues.party_id.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  </Col>
                  <Col xs={1} sm={1} md={1} lg={1}>
                    <div>
                      <a
                        className={`display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5  `}
                      >
                        <span
                          className="svg-icon svg-icon-md svg-icon-light"
                          onClick={() => {
                            setGet(true);
                            setShowParty(true);
                          }}
                        >
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/New/Search.svg"
                            )}
                          />
                        </span>
                      </a>
                    </div>
                  </Col>
                  {formValues.party_code.value !== "" && (
                    <div
                      className="ml-5"
                      style={{ marginTop: "22px", cursor: "pointer" }}
                      onClick={() => {
                        setFormValues({
                          ...formValues,
                          party_id: {
                            value: "",
                            error: false,
                            required: "Y",
                          },
                          party_code: {
                            value: "",
                            error: false,
                            required: "N",
                          },
                          party_name: {
                            value: "",
                            error: false,
                            required: "N",
                          },
                        });
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/New/x-square.svg"
                          )}
                        />
                      </span>
                    </div>
                  )}
                </Row>
                <RedditTextField
                  label="Carrier Name"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="party_name"
                  onChange={handleChange}
                  value={formValues.party_name.value}
                />
                <RedditTextField
                  label="Driver’s Name"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="driver_name"
                  onChange={handleChange}
                  value={formValues.driver_name.value}
                />
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                {" "}
                <RedditTextField
                  label="Driver’s Contact No."
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  type="number"
                  fullWidth
                  name="driver_contact"
                  onChange={handleChange}
                  value={formValues.driver_contact.value}
                />
                <RedditTextField
                  label="Description"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  multiline
                  rows="4"
                  name="description"
                  onChange={handleChange}
                  value={formValues.description.value}
                />
              </Col>
            </Row>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleSave} variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalPartyRadio
        isOpen={showParty}
        setShow={setShowParty}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFields}
        fields={fields}
        id={id}
        get={get}
        setGet={setGet}
      />
    </>
  );
};
